import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import logoPricesmart from '../../images/logo-pricesmart.svg'
import Multicanalidad from '../botones/multiprince'
import { BeneficiosTitular } from './beneficios'

const Wrapper = styled.div`
  padding: 0 20px;
  text-align: center;

  ${breakpoint('tablet')`
    max-width: 1000px;
    margin: 0 auto;
    padding: 0;
  `}
`

const BlueBarWrapper = styled(Wrapper)`
  ${breakpoint('tablet')`
    display: flex;
    flex-direction: row;
  `}
`

const TarjetaContainer = styled.div`
  width: 70%;
  margin: 40px auto;
  position: relative;
  padding-top: 50%;

  ${breakpoint('tablet')`
    width: 50%;
  `}

  img {
    width: 119%;
    max-width: 119%;
    display: block;
    position: absolute;
    top: 0;
    right: -19.5%;

    ${breakpoint('tablet')`
      width: 80%;
      max-width: 80%;
      right: 0;
      top: -20px;
    `}
  }
`

const Titular = styled.div`
  ${breakpoint('tablet')`
    margin-top: 40px;
  `}
`

const LogoContainer = styled.div`
  padding: 40px 40px 20px;
  ${breakpoint('tablet')`
    display: none;
  `}
`

const Disclaimer = styled.div`
  margin: 0 0 40px;
  font-size: 13px;
  ${breakpoint('tablet')`
    width: 50%;
    margin: -15px 0 15px;
  `}
`

const BlueBar = styled.div`
  background: rgba(0, 88, 162, 1);
  padding: 40px 0;
  color: #fff;
  margin-bottom: 40px;
`

const BlueBarDescription = styled.div`
  padding: 0 20px;

  ${breakpoint('tablet')`
    font-size: 1.5em;
    flex: none;
    width: 52%;
    text-align: left;
    padding: 0 0 0 20px;
  `}

  ${breakpoint('desktop')`
    width: 55%;
    padding: 0;
  `}
`

const Boton = styled.a`
  display: inline-block;
  background: #fff;
  color: rgba(0, 88, 162, 1);
  padding: 1em 1.6em;
  width: auto;
  margin: 20px auto 0;
  text-align: center;
  text-decoration: none;
  font-size: 16px;
  text-transform: uppercase;
  font-weight: bold;
  border-radius: 2px;
`

const FirstRow = styled.div`
  ${breakpoint('tablet')`
    display: flex;
    flex-direction: row-reverse;
     & > div {
       flex: none;
       width: 50%;
       display: flex;
       align-items: center;
       justify-content: center;
       box-sizing: border-box;
       padding: 40px;
     }
  `}
`

export default ({
  cta,
  titular,
  descripcion,
  link,
  disclaimer,
  tarjeta_img,
  multicanalidad,
}) => (
  <div>
    <Wrapper>
      <Titular>
        <BeneficiosTitular>{titular}</BeneficiosTitular>
      </Titular>
      <FirstRow>
        <TarjetaContainer>
          <img src={tarjeta_img} alt="Tarjeta Pricesmart"/>
        </TarjetaContainer>
        <div>
          <Multicanalidad
            formulario="https://www.baccredomatic.com/es-cr/tarjetas/credito/solicitud/pricesmart"
            multicanalidad={multicanalidad}
          />
        </div>
      </FirstRow>
      <LogoContainer>
        <img src={logoPricesmart} alt="PriceSmart" />
      </LogoContainer>
      <Disclaimer>{disclaimer}</Disclaimer>
    </Wrapper>
    <BlueBar>
      <BlueBarWrapper>
        <BlueBarDescription>{descripcion}</BlueBarDescription>
        <Boton href={link}>{cta}</Boton>
      </BlueBarWrapper>
    </BlueBar>
  </div>
)
